import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const subNavigationDefaultVars = {
  '--sub-navigation-item-color': m('--action-text-default-color'),
  '--sub-navigation-item-hover-color': m('--action-text-hover-color'),
  '--sub-navigation-item-active-color': m('--action-text-active-color'),
  '--sub-navigation-indicator-hover-color': m('--action-indicator-hover-color'),
  '--sub-navigation-indicator-active-color': m('--action-indicator-active-color'),
  '--sub-navigation-box-shadow':
    '0 16px 32px -16px rgba(0, 0, 0, 0.08)' /* +16px vertical and -16px spread to prevent showing above the nav */,
};

export const subNavigationBlackBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
};

export const subNavigationYellowBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
};

export const subNavigationGrayBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
};

export const subNavigationWhiteBgVars: MotifComponentProps<MotifComponent.SUB_NAVIGATION> = {
  ...subNavigationDefaultVars,
};
